import { render, staticRenderFns } from "./TenantManager.vue?vue&type=template&id=2d2c2d2a&"
import script from "./TenantManager.vue?vue&type=script&lang=js&"
export * from "./TenantManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports